import { create } from 'zustand';

interface LayoutState {
  isModeModal: boolean;
  isSidebarOpen: boolean;
  setModeModal: (value: boolean) => void;
  toggleSidebar: () => void;
}

export const useLayoutStore = create<LayoutState>()(set => ({
  isModeModal: false,
  isSidebarOpen: false,
  setModeModal: isModeModal => set({ isModeModal }),
  toggleSidebar: () => set(s => ({ isSidebarOpen: !s.isSidebarOpen })),
}));
